module.exports = __webpack_public_path__ + "static/media/logog3.dd54d9e7.png";